import { inject, InjectionToken } from '@angular/core';

/**
 * Injection token for the storage key used to persist Quote Tool state in SessionStorage.
 *
 * Applications must provide this token with their specific storage key.
 *
 * @example
 * // In app.config.ts:
 * {
 *   provide: QUOTE_TOOL_STORAGE_KEY,
 *   useValue: 'QT_LITE_STATE'
 * }
 */
export const QUOTE_TOOL_STORAGE_KEY = new InjectionToken<string>('QUOTE_TOOL_STORAGE_KEY');

/**
 * Helper function to inject the Quote Tool storage key.
 *
 * @returns The storage key string
 *
 * @example
 * private readonly storageKey = getQuoteToolStorageKey();
 */
export const getQuoteToolStorageKey = () => inject(QUOTE_TOOL_STORAGE_KEY);
